import { Link } from "react-router-dom";
import { BuildStatusBadge } from "./BuildStatusBadge";
import { PlatformIcon } from "./PlatformIcon";
import type { Project } from "../../repositories/projectRepository";
import type { Build } from "../../repositories/buildRepository";

interface ProjectCardProps {
  project: Project;
  latestBuild?: Build | null;
}

export function ProjectCard({ project, latestBuild }: ProjectCardProps) {
  return (
    <Link to={`/projects/${project.id}`}>
      <div className="bg-card border border-border rounded-xl p-6 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5 transition-all cursor-pointer group">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-lg truncate group-hover:text-primary transition-colors">
              {project.name}
            </h3>
            {project.githubRepoFullName && (
              <div className="flex items-center gap-1 text-sm text-muted-foreground mt-1">
                <span className="material-symbols-outlined text-[16px]">code</span>
                <span className="truncate">{project.githubRepoFullName}</span>
              </div>
            )}
          </div>
          {latestBuild && (
            <div className="ml-3">
              <BuildStatusBadge status={latestBuild.status} />
            </div>
          )}
        </div>

        {project.description && (
          <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
            {project.description}
          </p>
        )}

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-2">
            <PlatformIcon platform="windows" enabled={project.buildWindows} />
            <PlatformIcon platform="linux" enabled={project.buildLinux} />
            <PlatformIcon platform="macos" enabled={project.buildMacos} />
          </div>
        </div>
      </div>
    </Link>
  );
}
